import axios from "axios";
import { baseUrl, load } from "../Pages/ApiCommonService";
import { expTokenProcessAndGenerate } from "./AuthApis";
import { IntegrationInstructions } from "@mui/icons-material";

const token = sessionStorage.getItem('token');

export const fetchQuoteCsrJob = async (pageNo: number, pageSize: number, brokerId: any, status: any, fromDate: any, todate: any, searchKey: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            PageNo: String(pageNo),
            PageSize: String(pageSize)
        });

        if (fromDate) {
            params.append('fromDate', String(fromDate));
        }

        if (todate) {
            params.append('toDate', String(todate));
        }

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('TenantId', String(brokerId));
        }

        // Add status param only if valid number
        if (typeof status === 'number' && !isNaN(status)) {
            params.append('status', String(status));
        }

        if (searchKey) {
            params.append('searchKey', String(searchKey));
        }

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetAllJobsForCsr?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};


export const fetchQuoteJob = async (pageNo: number, pageSize: number, brokerId: any, status: any, jobId: any, isCsr: boolean = false) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            pageNo: String(pageNo),
            pageSize: String(pageSize),
            searchKey: jobId || '',
        });

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('TenantId', String(brokerId));
        }

        // Add status param only if valid number
        if (typeof status === 'number' && !isNaN(status)) {
            params.append('status', String(status));
        }

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetAllJobs?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const viewQuoteJobActivityDetail = async (JobId: number, TenantId: number) => {   // Api call to get created job status in activity table
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetJobActivites?JobId=${JobId}&TenantId=${TenantId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching in activityDetails:', error);
        throw error;
    }
};

export const getJobByIdQuoteCompare = async (JobId: number, TenantId: number) => {   // Api call for download the Remarks data
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetJobById?JobId=${JobId}&TenantId=${TenantId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const getFileInfoByJobIdQuoteCompare = async (Id: number, TenantId: number) => {   // Api call for download the uploaded files for the respesctive jobTypeId
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetJobFilesByJobId?JobId=${Id}&TenantId=${TenantId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const getFileByFileId = async (fileId: number, tenantId: number) => {   //Api call for download the input files uploaded from model
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetFileByFileId?FileId=${fileId}&TenantId=${tenantId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in downloading the selected inputFile:', error);
        throw error;
    }
};

export interface CreateQCJobPayload {
    TenantId: number;
    LobID: number;
    JobTypeID: number;
    JobSubTypeID: number;
    ClientName: string;
    ReferenceUserId: number;
    ChecklistTypeID: number;
}

export const CreateQCJob = async (body: CreateQCJobPayload) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/CreateJob`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        return response;
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};

export const UploadQCDocument = async (
    isBaseDocument: boolean,
    JobId: number,
    TenantId: number,
    file: File
) => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem('token') || token
        );

        const formData = new FormData();
        formData.append('Files', file, file.name); // must match API param name

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/UploadQuoteFile`,
            formData,
            {
                params: {
                    IsBaseDocument: isBaseDocument,
                    JobId,
                    TenantId,
                },
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error uploading document:', error);
        throw error;
    }
};

export const ReuploadQCDocument = async (JobId: number, TenantId: number, file: File) => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem('token') || token
        );

        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/CsrReUploadSingleFile`,
            formData,
            {
                params: {
                    JobId,
                    TenantId,
                },
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error uploading document:', error);
        throw error;
    }
};

export const getLobsByBrokerId = async (brokerId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetAllLobs?TenantId=${brokerId}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const getCSRJobInfoStatus = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + 'api/QuoteCompare/GetAllStatusForCsr', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the jobinfo_status:', error);
        throw error;
    }
};

export const getQcJobStatus = async (TenantId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetAllStatus?TenantId=${TenantId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the jobinfo_status:', error);
        throw error;
    }
};

interface CreateActivityPayload {
    TenantId: number;
    JobId: number;
}

export const CreateQuoteActivity = async (body: CreateActivityPayload) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/CreateJobActivities`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};

export const fetchJobSummaryCnt = async (TenantId: number) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const params = new URLSearchParams({});
        if (TenantId) {
            params.append('TenantId', String(TenantId));
        }
        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetDashboardData?${params.toString()}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response.data;
        }
        throw new Error(`Unexpected response status: ${response.status}`);
    } catch (error: any) {
        if (error?.response?.status === 401) {
            load.reload()
            await expTokenProcessAndGenerate(sessionStorage.getItem('token'));
        }
        console.error('Error fetching summary_count:', error);
        throw error;
    }
};

export const fetchChartCount = async (TenantId: number) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const params = new URLSearchParams({});
        if (TenantId) {
            params.append('TenantId', String(TenantId));
        }
        const response = await axios.get(baseUrl + 'api/QuoteCompare/GetJobsCountBarChart?' + params.toString(), {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response
        }
    } catch (error: any) {
        if (error?.response?.status === 401) {
            load.reload()
            await expTokenProcessAndGenerate(sessionStorage.getItem('token'));
        }
        console.error('Error fetching lineOrbarchart_count:', error);
    }
};

export const fetchWeeklyChartCount = async (TenantId: number) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const params = new URLSearchParams({});
        if (TenantId) {
            params.append('TenantId', String(TenantId));
        }
        const response = await axios.get(baseUrl + 'api/QuoteCompare/GetJobsCountBarChartWeekly?' + params.toString(), {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response;
        }
    } catch (error: any) {
        console.error('Error fetching weekly chart count:', error);
    }
};

export const GetJobActivityInstanceError = async (InstanceId: string, TenantId: number) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const params = new URLSearchParams({});
        if (InstanceId) {
            params.append('InstanceId', String(InstanceId));
        }
        if (TenantId) {
            params.append('TenantId', String(TenantId));
        }
        const response = await axios.get(baseUrl + `api/QuoteCompare/GetJobActivityInstanceError?${params.toString()}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response.data;
        }
    } catch (error: any) {
        console.error('Error fetching weekly chart count:', error);
    }
};

interface RetryJobActivityPayload {
    TenantId: number;
    JobId: number;
    InstanceId: string;
}

export const RetryJobActivityByInstanceId = async (JobId: number, InstanceId: string, TenantId: number) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const body: RetryJobActivityPayload = {
            TenantId: TenantId,
            JobId: JobId,
            InstanceId: InstanceId
        }
        const response = await axios.post(baseUrl + `api/QuoteCompare/RetryJobActivityByInstanceId`, body, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response;
        }
    } catch (error: any) {
        console.error('Error fetching weekly chart count:', error);
    }
};

export const DispatchJob = async (body: CreateActivityPayload) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/DispatchJob`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};
interface ReprocessJobPayload {
    TenantId: number;
    JobId: number;
    ToTenantId: number;
}

export const TransferJob = async (body: ReprocessJobPayload) => {  // Api call for re-trigger to create a new-jobid for already created existing onr
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + `api/QuoteCompare/TransferJob`, body, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error("Error in re-trigger for creating the job again:", error);
        throw error;
    }
};

export const DeleteJob = async (JobId: number, TenantId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(`${baseUrl}api/QuoteCompare/DeleteJob?JobId=${JobId}&TenantId=${TenantId}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
            params: { job_id: JobId }
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error deleting the job:', error);
        throw error;
    }
};

export const GetOverallStatusReport = async (pageNo: number, pageSize: number, brokerId: any, fromDate: any, todate: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            PageNo: String(pageNo),
            PageSize: String(pageSize)
        });

        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }

        if (todate) {
            params.append('ToDate', String(todate));
        }

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('TenantId', String(brokerId));
        }

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetOverallStatusReport?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const GetFileUploadReport = async (pageNo: number, pageSize: number, brokerId: any, fromDate: any, todate: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            PageNo: String(pageNo),
            PageSize: String(pageSize)
        });

        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }

        if (todate) {
            params.append('ToDate', String(todate));
        }

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('TenantId', String(brokerId));
        }

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetFileUploadReport?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const GetproductionReport = async (pageNo: number, pageSize: number, brokerId: any, fromDate: any, todate: any, statusId: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            PageNo: String(pageNo),
            PageSize: String(pageSize)
        });

        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }

        if (todate) {
            params.append('ToDate', String(todate));
        }
        if (todate) {
            params.append('ToDate', String(todate));
        }

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('TenantId', String(brokerId));
        }

        if (statusId !== undefined && statusId !== null && statusId !== 'All' && statusId !== -1) {
            params.append('StatusId', String(statusId));
        }

        const response = await axios.get(`${baseUrl}api/QuoteCompare/GetproductionReport?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const GetBrokerApplicationsById = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/master/GetBrokerApplicationsById`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the jobinfo_status:', error);
        throw error;
    }
};

export const ExportQcProductionReport = async (brokerId: any, fromDate: any, toDate: any, status: any) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({});
        if (brokerId) {
            params.append('TenantId', String(brokerId));
        }
        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }
        if (toDate) {
            params.append('ToDate', String(toDate));
        }
        if (status) {
            params.append('StatusId', String(status));
        }

        let url = `${baseUrl}api/QuoteCompare/ExportQcProductionReport?${params.toString()}`;

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

export const ExportQcFileUploadDetailsReport = async (brokerId: any, fromDate: any, toDate: any) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({});
        if (brokerId) {
            params.append('TenantId', String(brokerId));
        }
        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }
        if (toDate) {
            params.append('ToDate', String(toDate));
        }

        let url = `${baseUrl}api/QuoteCompare/ExportQcFileUploadDetailsReport?${params.toString()}`;

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

export const ExportQcOverallStatusReport = async (brokerId: any, fromDate: any, toDate: any) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({});
        if (brokerId) {
            params.append('TenantId', String(brokerId));
        }
        if (fromDate) {
            params.append('FromDate', String(fromDate));
        }
        if (toDate) {
            params.append('ToDate', String(toDate));
        }

        let url = `${baseUrl}api/QuoteCompare/ExportQcOverallStatusReport?${params.toString()}`;

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

interface CreateActivityPayload {
    TenantId: number;
    JobId: number;
}

export const UpdateJobAsProcessingFailed = async (body: CreateActivityPayload) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/UpdateJobAsProcessingFailed`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};

export const GetQcAccessList = async () => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/master/GetQcAccessList`;

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        return response;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

export const UpdateQuoteCompareAccess = async (brokerId: number, giveAccess: boolean) => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        params.append("brokerId", brokerId.toString());
        params.append("giveAccess", giveAccess.toString());

        let url = `${baseUrl}api/master/UpdateQuoteCompareAccess?${params.toString()}`;

        const response = await axios.put(url, null, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        return response;
    } catch (error) {
        console.error('Error in downloading ProductionReport:', error);
        throw error;
    }
};

export const getAllQuestionsMaster = async (tenant_Id: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/getAllQuestionsMaster?TenantId=${tenant_Id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error in getAllQuestionsMaster", error);
    }
}

export const getAllCoverageSpecification = async (tenant_Id: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/getAllCoverageSpecification?TenantId=${tenant_Id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error in getAllCoverageSpecification", error);
    }
}

export const getAllLobMaster = async (tenant_Id: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/getAllLobMaster?TenantId=${tenant_Id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error in getAllLobMaster", error);
    }
}

export const getAllQuestionConfig = async (tenant_Id: number, lobId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/QuoteCompare/getAllQuestionConfig?LobId=${lobId}&TenantId=${tenant_Id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error in getAllQuestionConfig", error);
    }
}

export const deleteQuoteQuestionConfig = async (Id: number, TenantId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(`${baseUrl}api/QuoteCompare/deleteQuoteQuestionConfig?Id=${Id}&TenantId=${TenantId}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error deleting the job:', error);
        throw error;
    }
};

interface AddLobQuestionMap {
    LobQuestionID: number;
    LobID: number;
    QuestionCode: number;
    CoverageSpecCode: number;
    CreatedOn: string;
    sorted_order: number;
}

export const addorUpdateQuoteQuestionConfig = async (body: AddLobQuestionMap, TenantId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/addorUpdateQuoteQuestionConfig?TenantId=${TenantId}`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};

export const editQuoteQuestionConfig = async (body: AddLobQuestionMap, TenantId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/QuoteCompare/editQuoteQuestionConfig?TenantId=${TenantId}`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};